import { Component, OnInit } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Component({
    selector: 'app-link-expired',
    templateUrl: './link-expired.component.html',
    styleUrl: './link-expired.component.scss',
    standalone: false
})
export class LinkExpiredComponent implements OnInit {
  ngOnInit(): void {
    Sentry.addBreadcrumb({
      category: 'secure-data-location',
      message: 'secure_link_invalid_displayed',
      level: 'info'
    });
  }
}
